module.exports = __webpack_public_path__ + "fonts/NJ4vxlgWwWbEsv18dAhqnn-_kf6ByYO6CLYdB4HQE-Y.woff2";